import { render, staticRenderFns } from "./EmailAuthentication.vue?vue&type=template&id=5dccb205"
import script from "./EmailAuthentication.vue?vue&type=script&lang=js"
export * from "./EmailAuthentication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports